import { useT } from '../../../../i18n';
import type { BoDich } from '../../../../i18n';
import { soVN } from '../../../../lib/dinh-dang';
import { phamViCidr } from '../../nghiep-vu/pham-vi-ip';

/**
 * Phạm vi của một CIDR, tách hai phần để chữ phụ trong bảng không bẻ "256 địa
 * chỉ" giữa chừng: `khoang` là "113.185.44.0 – 113.185.44.255" (chỉ có với dải
 * đếm được), `so` là "256 địa chỉ", "1 địa chỉ" hoặc "Dải IPv6 /64".
 */
function phanPhamVi(cidr: string, t: BoDich['t'], locale: string): { khoang?: string; so: string } | null {
  const pv = phamViCidr(cidr);
  if (!pv) return null;
  if (pv.loai === 'mot') return { so: t('caiDat.cidr.phamViMot') };
  if (pv.loai === 'daiLon') return { so: t('caiDat.cidr.phamViDaiLon', { tienTo: pv.tienTo }) };
  return {
    khoang: t('caiDat.cidr.phamViKhoang', { dau: pv.dau, cuoi: pv.cuoi }),
    so: t('caiDat.cidr.phamViSo', { so: soVN(pv.soDiaChi, locale) }),
  };
}

/** Chữ phụ dưới mỗi CIDR trong bảng: dòng này phủ bao nhiêu địa chỉ. */
export function ChuPhuPhamVi({ cidr }: { cidr: string }) {
  const { t, locale } = useT();
  const p = phanPhamVi(cidr, t, locale);
  if (!p) return null;
  return (
    <span className="text-2xs text-content-muted">
      {p.khoang && <>{p.khoang} · </>}
      <span className="whitespace-nowrap">{p.so}</span>
    </span>
  );
}
